import React, { useState, useEffect, useMemo, useRef } from "react";
import { getBranchOwner, post, api } from "@config";
import { Modal } from "react-bootstrap";
import AIEmitButton from "../../../../../components/AIEmitButton";
import { validateCNPJ, validateCPF } from "@parts/document-component"

import Provider from "../components/provider";
import Service from "../components/service";
import RPS from "../components/rps";
import { mapTest } from "../../../../../components/pages/products/map.test";
import SweetAlert from "react-bootstrap-sweetalert";

import { useNfse } from '../context'
import {
    ActionButton,
    StyledCard,
    ScreenContainer,
    ScreenContent,
    HeroHeader,
    HeroHeaderTitle,
    HeroIcon,
    StepperWrapper,
    StepperItem,
    StepperMarker,
    FooterActions,
} from "../components/styles";
import ImportServiceWithAIModal from "../../components/ImportServiceWithAI";
import { getExigibilidadeFromNatOp } from '../utils/natOpToExigibilidade';
import CNAES_ITEM from '../utils/cnae_item.json';
import { normalizePrefectureError, DEFAULT_MESSAGES } from '../utils/errorHandler';
import BuyNotesPack from '../../../../AppViews/Plans/BuyAdditionalNotes';



function SwitchComponent(props) {
    const { step } = props;
    switch (step) {
        case 0:
            return <Provider />;
        case 1:
            return <Service />;
        default:
            return null;
    }
}

export default function NfPaulistanaPattern() {
    const { rps, taker, service, setRps, setTaker, setService, setItems, clearDraft } = useNfse();
    const [step, setStep] = useState(0);
    const hasDraftData = useMemo(() => {
        const hasRps = rps && Object.keys(rps).length;
        const hasTaker = taker && Object.keys(taker).length;
        const hasService = service && Object.keys(service).length;
        return Boolean(hasRps || hasTaker || hasService);
    }, [rps, taker, service]);

    useEffect(() => {
        const duplicateData = localStorage.getItem('nfseDuplicateData');
        if (duplicateData) {
            try {
                const data = JSON.parse(duplicateData);
                if (data.rps) setRps(data.rps);
                if (data.taker) setTaker(data.taker);
                if (data.service) setService(data.service);
                if (data.items) setItems(data.items);
                localStorage.removeItem('nfseDuplicateData');
            } catch(e) {
                console.error("Error parsing duplicate data", e);
            }
        }
    }, [setRps, setTaker, setService, setItems]);
    const takerRequired = ["cpf_cnpj", "state", "city"];
    const [modalError, setModalError] = useState({ show: false, title: "", description: "", code: null, tag: null, details: [], action: null, actionLabel: null, actionUrl: null, rawResponse: "" });
    const [showTechnicalDetails, setShowTechnicalDetails] = useState(false);
    const [modalValidation, setModalValidation] = useState({ show: false, listErrors: [] });
    const [modalSending, setModalSending] = useState(false);
    // Guard síncrono contra duplo clique/duplo submit — setState é assíncrono
    // e não bloqueia uma segunda chamada de onEmit() disparada antes do re-render.
    const isEmittingRef = useRef(false);
    const [nfseModalSuccess, setNfseModalSuccess] = useState(false);
    const [nfseData, setNfseData] = useState(null);
    const [showAIModal, setShowAIModal] = useState(false);

    const handleApplyAIData = (data, options) => {
        if (!data) return;

        const mergedTaker = Object.assign({}, taker, data.taker || {});
        const mergedService = Object.assign({}, service, data.service || {});

        // Fallback: se a IA/backend não trouxe o Item LC 116, deriva do CNAE escolhido
        const cnaeDigits = String(mergedService.cnae_code || "").replace(/\D/g, "");
        const cnaeInfo = cnaeDigits ? CNAES_ITEM[cnaeDigits] : null;
        if (cnaeInfo && cnaeInfo.service_code && !mergedService.item_list_service) {
            mergedService.item_list_service = cnaeInfo.service_code;
            if (!mergedService.service_code) {
                mergedService.service_code = cnaeInfo.service_code.replace(/\D/g, "");
            }
            if (data.service) {
                data = Object.assign({}, data, { service: Object.assign({}, data.service, {
                    item_list_service: mergedService.item_list_service,
                    service_code: mergedService.service_code
                }) });
            }
        }

        if (data.taker) {
            setTaker(prev => ({
                ...prev,
                ...data.taker
            }));
        }
        if (data.service) {
            setService(prev => ({
                ...prev,
                ...data.service
            }));
        }
        if (data.items && data.items.length > 0) {
            setItems(data.items);
        }

        if (options && options.autoEmit) {
            onEmit({
                taker: mergedTaker,
                service: mergedService,
                rps: rps
            });
        }
    };

    const removeTakerErrors = () => {
        // No longer used, handled by Modal
    };

    const handleClearDraft = () => {
        clearDraft();
        setStep(0);
    };

    const validateTakerData = (targetTaker) => {
        const currentTaker = targetTaker || taker;
        let listErrors = [];
        const required = ["cpf_cnpj", "name", "postal_code", "address", "city", "state", "district", "street_number"];
        const fieldNames = {
            "cpf_cnpj": "CPF/CNPJ",
            "name": "Razão Social/Nome",
            "postal_code": "CEP",
            "address": "Endereço",
            "city": "Cidade",
            "state": "Estado",
            "district": "Bairro",
            "street_number": "Número"
        };

        if (!currentTaker || !currentTaker.original_id) {
            listErrors.push("O Tomador precisa estar cadastrado como cliente na base de dados para emitir a NFS-e. Clique em 'Cadastrar como Cliente' na seção do Tomador.");
        }

        for (let field of required) {
            let fieldValue = currentTaker ? currentTaker[field] : null;

            if (field === "cpf_cnpj") {
                let doc = !fieldValue ? "" : String(fieldValue).replace(/\D+/g, "");
                if (!doc) {
                    listErrors.push("Insira um CPF/CNPJ válido do Tomador");
                } else if (doc.length <= 11 && !validateCPF(doc)) {
                    listErrors.push("Insira um CPF válido para o Tomador");
                } else if (doc.length > 11 && !validateCNPJ(doc)) {
                    listErrors.push("Insira um CNPJ válido para o Tomador");
                }
            } else if (!fieldValue || String(fieldValue).trim() === "") {
                listErrors.push(`O campo ${fieldNames[field]} do Tomador é obrigatório`);
            }
        }

        if (listErrors.length === 0) {
            return true;
        } else {
            setModalValidation({ show: true, listErrors });
            return false;
        }
    };

    const validateServiceData = (targetService) => {
        const currentService = targetService || service;
        let listErrors = [];

        if (!currentService || !currentService.nat_op) listErrors.push("Natureza da Operação do Serviço é obrigatória");
        if (!currentService || !currentService.cnae_code) listErrors.push("Atividade (CNAE) do Serviço é obrigatória");
        if (!currentService || !currentService.item_list_service) listErrors.push("Item Lei do Serviço é obrigatório");
        if (!currentService || !currentService.service_code) listErrors.push("Código do Serviço é obrigatório");
        if (!currentService || !currentService.description || String(currentService.description).trim() === "") listErrors.push("Descrição da Nota é obrigatória");
        const branch = getBranchOwner();
        const cityCodeProvider = (currentService && currentService.city_code_provider) || (branch && branch.address && branch.address.city_code) || "";
        if (!cityCodeProvider || String(cityCodeProvider).trim() === "") {
            listErrors.push("Município da Prestação do Serviço (Cód. IBGE) é obrigatório");
        }

        if (listErrors.length === 0) {
            return true;
        } else {
            setModalValidation({ show: true, listErrors });
            return false;
        }
    };

    const closePrefectureErrorModal = () => {
        setModalError({ show: false, title: "", description: "", code: null, tag: null, details: [], action: null, actionLabel: null, actionUrl: null, rawResponse: "" });
        setShowTechnicalDetails(false);
    };

    const onEmit = (customData) => {
        // Bloqueia cliques/chamadas concorrentes: sem isso, dois cliques rápidos no
        // botão de emissão disparam 2 POSTs de criação de NFS-e antes do primeiro
        // re-render (setModalSending é assíncrono), gerando envio duplicado do
        // mesmo RPS para a prefeitura.
        if (isEmittingRef.current) {
            return;
        }

        const currentTaker = (customData && customData.taker) ? customData.taker : taker;
        const currentService = (customData && customData.service) ? customData.service : service;
        const currentRps = (customData && customData.rps) ? customData.rps : rps;

        const takerValid = validateTakerData(currentTaker);
        if (!takerValid) return;

        const serviceValid = validateServiceData(currentService);
        if (!serviceValid) {
            setStep(1);
            return;
        }

        isEmittingRef.current = true;

        const branch = getBranchOwner();
        currentRps.rps_nat_op = (currentService.nat_op && currentService.nat_op.value) || currentRps.rps_nat_op || "1";

        const data = {
            rps: currentRps,
            taker: currentTaker,
            service: Object.assign({}, currentService)
        };
        data.service.quantity = 1;

        const natOpValue = (currentService.nat_op && currentService.nat_op.value) || currentRps.rps_nat_op || "1";
        data.service.exigibilidade_iss = getExigibilidadeFromNatOp(natOpValue);
        data.service.iss_retained = data.service.iss_retained || "2";
        data.service.city_code_provider = data.service.city_code_provider || (branch && branch.address && branch.address.city_code) || "";

        if (data.taker && data.taker.cpf_cnpj) {
            data.taker.cpf_cnpj = String(data.taker.cpf_cnpj).replace(/\D+/g, "");
        }

        setModalSending(true);
        const url = `${api.nfse.nfse}?branch_owner=${branch.id}`;

        const onSuccess = (nfse) => {
            isEmittingRef.current = false;
            setModalSending(false);
            clearDraft();
            setNfseData(nfse);
            setNfseModalSuccess(true);
        };

        const errorCallback = (error) => {
            let rawText = "";
            try {
                if (error && typeof error.response === "string") rawText = error.response;
                else if (error && error.responseText) rawText = error.responseText;
                else if (error && error.data && typeof error.data === "string") rawText = error.data;
                else rawText = JSON.stringify(error);
            } catch(e) { rawText = String(error); }
            isEmittingRef.current = false;
            setModalSending(false);
            const normalized = normalizePrefectureError(error);
            normalized.rawResponse = rawText;
            if (normalized.details.length === 0 && rawText) {
                normalized.details = ["Resposta bruta: " + rawText];
            }
            setModalError(normalized);
        };

        post(url, data, onSuccess, errorCallback);
    };

    const changeStep = (e) => {
        let i = parseInt(e.target.value || e.target.getAttribute('value') || e.currentTarget.value);

        if (step === 0) {
            const next = validateTakerData();
            if (!next && i > 0) {
                return;
            }
        } else if (step === 1 && i > 0) {
            const serviceNext = validateServiceData();
            if (!serviceNext) {
                return;
            }
            onEmit();
            return;
        }

        setStep(prev => prev + i);
    };

    let nextStepTextButton = "";
    let prevStepTextButton = "";

    switch (step) {
        case 0:
            nextStepTextButton = "Serviço";
            break;
        case 1:
            prevStepTextButton = "Dados do Tomador";
            nextStepTextButton = "Emitir";
            break;
        default:
            break;
    }

    return (
        <ScreenContainer>
            <ScreenContent>
                <HeroHeader>
                    <HeroHeaderTitle>
                        <HeroIcon>
                            <i className="fas fa-file-invoice-dollar"></i>
                        </HeroIcon>
                        <div>
                            <h1 className="m-0" style={{ fontWeight: 800, fontSize: '1.75rem', color: '#101828' }}>Emitir NFS-e</h1>
                            <span style={{ color: '#475467', fontSize: '0.95rem', fontWeight: 500 }}>Preencha os dados em etapas para emissão da nota fiscal</span>
                        </div>
                    </HeroHeaderTitle>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <AIEmitButton onClick={() => setShowAIModal(true)} />
                        <ActionButton
                            variant="secondary"
                            onClick={handleClearDraft}
                            disabled={!hasDraftData}
                            $stackedOnMobile
                        >
                            <i className="fas fa-eraser" style={{ marginRight: '8px' }}></i>
                            Limpar rascunho
                        </ActionButton>
                    </div>
                </HeroHeader>

                <StyledCard style={{ background: '#fff' }}>
                    <StepperWrapper>
                        <StepperItem active={step >= 0}>
                            <StepperMarker active={step >= 0}>1</StepperMarker>
                            <strong style={{ color: step >= 0 ? '#0088cc' : '#667085' }}>Prestador e Tomador</strong>
                        </StepperItem>
                        <StepperItem active={step >= 1}>
                            <StepperMarker active={step >= 1}>2</StepperMarker>
                            <strong style={{ color: step >= 1 ? '#0088cc' : '#667085' }}>Serviço e RPS</strong>
                        </StepperItem>
                    </StepperWrapper>
                </StyledCard>

                <RPS />

                <SwitchComponent step={step} />

                <FooterActions>
                    {step > 0 ? (
                        <ActionButton
                            variant="secondary"
                            value={-1}
                            onClick={changeStep}
                            $stackedOnMobile
                            style={{ background: '#fff', flex: 1 }}
                        >
                            <i className="fas fa-arrow-left"></i> Voltar ({prevStepTextButton})
                        </ActionButton>
                    ) : (
                        <div style={{ flex: 1 }} />
                    )}
                    <ActionButton
                        id={mapTest.emitNfse.nextStepButton}
                        variant="primary"
                        value={1}
                        onClick={changeStep}
                        disabled={modalSending}
                        $stackedOnMobile
                        style={{ flex: 1 }}
                    >
                        Próximo: {nextStepTextButton} <i className="fas fa-arrow-right"></i>
                    </ActionButton>
                </FooterActions>

                <Modal show={modalSending} centered backdrop="static">
                    <Modal.Body style={{ padding: '32px', textAlign: 'center' }}>
                        <i className="fas fa-circle-notch fa-spin text-info mb-3" style={{ fontSize: '3rem' }}></i>
                        <h4 style={{ fontWeight: 700 }}>Transmitindo NFS-e...</h4>
                        <p className="text-secondary m-0">Por favor, aguarde a resposta da prefeitura.</p>
                    </Modal.Body>
                </Modal>

                <SweetAlert
                    show={modalError.show}
                    showCancel={false}
                    showConfirm={false}
                    type={modalError.action === 'buy_notes' || modalError.action === 'upgrade_plan' ? 'warning' : 'error'}
                    title={<div style={{ fontWeight: 800 }}>{modalError.title || "Erro na emissão!"}</div>} >
                    <div style={{ textAlign: 'left', color: '#475467' }}>
                        <p style={{ fontSize: '1.05rem', margin: '12px 0', fontWeight: 600, color: '#101828' }}>
                            {modalError.description || DEFAULT_MESSAGES.prefectureError}
                        </p>
                        {modalError.code ? (
                            <p style={{ marginBottom: '4px', fontSize: '0.9rem', color: '#667085' }}>
                                <strong>Código:</strong> {modalError.code}
                            </p>
                        ) : null}
                        {modalError.tag && modalError.tag !== 'other_error' ? (
                            <p style={{ marginBottom: '8px', fontSize: '0.9rem', color: '#667085' }}>
                                <strong>Identificador:</strong> <code>{modalError.tag}</code>
                            </p>
                        ) : null}
                        {modalError.details && modalError.details.length ? (
                            <div style={{ background: '#F8F9FA', border: '1px solid #EAECF0', borderRadius: '8px', padding: '12px', marginTop: '12px', marginBottom: '12px' }}>
                                <ul style={{ paddingLeft: '18px', margin: 0 }}>
                                    {modalError.details.map((detail, idx) => (
                                        <li key={idx} style={{ fontSize: '0.9rem', marginBottom: idx === modalError.details.length - 1 ? 0 : '6px', color: '#344054' }}>
                                            {detail}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ) : null}

                        {modalError.rawResponse ? (
                            <div style={{ marginTop: '8px', marginBottom: '12px' }}>
                                <button
                                    type="button"
                                    onClick={() => setShowTechnicalDetails(prev => !prev)}
                                    style={{ background: 'none', border: 'none', padding: 0, color: '#0088cc', fontSize: '0.85rem', cursor: 'pointer', textDecoration: 'underline' }}
                                >
                                    {showTechnicalDetails ? "Ocultar detalhes técnicos" : "Ver resposta técnica do servidor"}
                                </button>
                                {showTechnicalDetails && (
                                    <pre style={{ marginTop: '8px', padding: '8px', background: '#1E293B', color: '#E2E8F0', borderRadius: '6px', fontSize: '0.75rem', maxHeight: '120px', overflowY: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                        {modalError.rawResponse}
                                    </pre>
                                )}
                            </div>
                        ) : null}
                    </div>

                    {modalError.action === "buy_notes" ? (
                        <div style={{ marginTop: '16px', marginBottom: '10px' }}>
                            <BuyNotesPack id="nfse-error-modal-buy-notes" />
                        </div>
                    ) : null}

                    {modalError.actionUrl && modalError.action !== "buy_notes" ? (
                        <ActionButton
                            variant="primary"
                            style={{ width: '100%', marginBottom: '10px' }}
                            onClick={() => window.location.href = modalError.actionUrl}
                        >
                            <i className="fas fa-external-link-alt" style={{ marginRight: '8px' }}></i>
                            {modalError.actionLabel || "Acessar"}
                        </ActionButton>
                    ) : null}

                    <ActionButton variant="secondary" style={{ width: '100%', marginTop: '4px' }} onClick={closePrefectureErrorModal}>
                        Entendi e Fechar
                    </ActionButton>
                </SweetAlert>

                <SweetAlert
                    show={modalValidation.show}
                    showCancel={false}
                    showConfirm={false}
                    type='error'
                    title={<div style={{ fontWeight: 800 }}>Verifique os dados!</div>} >
                    <ul style={{ textAlign: 'left', margin: '16px 0', paddingLeft: '24px' }}>
                        {modalValidation.listErrors && modalValidation.listErrors.map((e, idx) => <li key={idx} style={{ color: '#475467', marginBottom: '8px' }}>{e}</li>)}
                    </ul>
                    <ActionButton variant="secondary" style={{ width: '100%' }} onClick={() => setModalValidation({ show: false, listErrors: [] })}>
                        Ok, entendi
                    </ActionButton>
                </SweetAlert>

                <Modal show={nfseModalSuccess} onHide={() => window.location.reload()} centered>
                    <Modal.Body style={{ padding: '32px', textAlign: 'center' }}>
                        <div style={{ width: '64px', height: '64px', background: '#D1FADF', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px auto' }}>
                            <i className="fas fa-check text-success" style={{ fontSize: '2rem' }}></i>
                        </div>
                        <h2 style={{ fontWeight: 800, color: '#101828' }}>NFS-e Autorizada com Sucesso!</h2>
                        <p className="text-secondary mb-4">A nota fiscal foi processada pela prefeitura e está pronta para uso.</p>

                        {nfseData && (
                            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
                                <ActionButton variant="secondary" onClick={() => window.open(nfseData.pdf_url, "_blank")}>
                                    <i className="fas fa-file-pdf text-danger"></i> Imprimir PDF
                                </ActionButton>
                                <ActionButton variant="secondary" onClick={() => window.open(nfseData.xml_url, "_blank")}>
                                    <i className="fas fa-file-code text-info"></i> Baixar XML
                                </ActionButton>
                            </div>
                        )}

                        <ActionButton variant="primary" style={{ width: '100%', marginTop: '24px' }} onClick={() => window.location.reload()}>
                            Emitir Nova Nota
                        </ActionButton>
                    </Modal.Body>
                </Modal>
                <ImportServiceWithAIModal
                    show={showAIModal}
                    onHide={() => setShowAIModal(false)}
                    onApplyData={handleApplyAIData}
                />
            </ScreenContent>
        </ScreenContainer>
    );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/emit/patterns/index.jsx